
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1B2xl", function(module, exports) {

$parcel$export(module.exports, "getRandomUniqueNumbers", () => $ecc34a56e3ca8c79$export$cbb224b90d3f0722);
function $ecc34a56e3ca8c79$export$cbb224b90d3f0722(count, min, max) {
    const numbers = [];
    while(numbers.length < count){
        const num = Math.floor(Math.random() * (max - min + 1)) + min;
        if (!numbers.includes(num)) numbers.push(num);
    }
    return numbers;
}

});

parcelRegister("9m5D8", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1b25e149e99979c$export$2e2bcd8739ae039);

var $erVR3 = parcelRequire("erVR3");

var $lO7zi = parcelRequire("lO7zi");

var $hCdov = parcelRequire("hCdov");
class $c1b25e149e99979c$export$2e2bcd8739ae039 {
    cCoord;
    center = new (0, $lO7zi.default)("O");
    tags = [];
    constructor(cCoord, tags){
        this.cCoord = cCoord;
        this.tags = tags.map((tag)=>new (0, $lO7zi.default)(tag));
        this.updateCenter();
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).startedCircleAnim, ()=>this.setAllVisible(false));
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).completedCircleAnim, ()=>this.setAllVisible(true));
    }
    updateCenter = ()=>this.center.updateCoord({
            x: this.cCoord.x + 21,
            y: this.cCoord.y + 21
        });
    setAllVisible = (visible)=>[
            this.center,
            ...this.tags
        ].forEach((pTag)=>pTag.visible = visible);
    updateCoord(radians, radius) {
        const coords = (0, $hCdov.default)(this.cCoord, radians, radius + 30);
        coords.forEach((coord, cI)=>this.tags[cI].updateCoord(coord));
    }
}

});

parcelRegister("g4gW0", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0d65a8310461d1d$export$2e2bcd8739ae039);

var $iuB9z = parcelRequire("iuB9z");

var $9ec1t = parcelRequire("9ec1t");

var $i30uN = parcelRequire("i30uN");

var $3f3J1 = parcelRequire("3f3J1");
class $b0d65a8310461d1d$export$2e2bcd8739ae039 extends $iuB9z.Container {
    Layers = (0, $9ec1t.default).getInstance();
    AngleValue;
    arc;
    arcStroke;
    tag;
    startRadian;
    endRadian;
    degree;
    fillColor;
    smallDistance = 100;
    smallDistanceOffset = 0;
    addSmallDis = true;
    constructor(tag, angleColor, smallDistanceOffset = 0, addCon = false, addSmallDis = true){
        super();
        this.tag = tag;
        this.fillColor = angleColor.color;
        this.smallDistanceOffset = smallDistanceOffset;
        this.addSmallDis = addSmallDis;
        this.AngleValue = new (0, $i30uN.default)({
            x: -100,
            y: -100
        }, angleColor.textColor);
        this.addArc();
        !addCon && this.addToLayer();
    }
    addToLayer = ()=>this.Layers.Bottom.addChild(this);
    addArc() {
        this.arc = new $iuB9z.Graphics();
        this.addChild(this.arc);
        this.arcStroke = new $iuB9z.Graphics();
        this.addChild(this.arcStroke);
    }
    setVisible(status) {
        this.visible = status;
        this.AngleValue.visible = status;
    }
    draw(cCoord, startRadian, endRadian, degree, cClockwise) {
        const sD = this.smallDistance;
        const radian = sD <= 76 + this.smallDistanceOffset && this.addSmallDis ? Math.max((sD - this.smallDistanceOffset) / 2, 15) : 38;
        this.degree = degree;
        this.startRadian = startRadian;
        this.endRadian = endRadian;
        if (degree == 90) {
            this.arcStroke.clear();
            (0, $3f3J1.drawSquare)(this.arc, radian, startRadian, endRadian, this.fillColor, cClockwise);
        } else {
            (0, $3f3J1.drawArc)(this.arcStroke, radian, startRadian, endRadian, 3, 0x000000, cClockwise, true);
            (0, $3f3J1.drawArc)(this.arc, radian / 2, startRadian, endRadian, radian, this.fillColor, cClockwise, false);
        }
        const initialAngle = cClockwise ? endRadian : startRadian;
        this.AngleValue.setAngleValue(cCoord, initialAngle, degree, radian);
    }
}

});
parcelRegister("i30uN", function(module, exports) {

$parcel$export(module.exports, "default", () => $6935df93860f2c37$export$2e2bcd8739ae039);

var $iuB9z = parcelRequire("iuB9z");

var $9ec1t = parcelRequire("9ec1t");

var $eymUv = parcelRequire("eymUv");
class $6935df93860f2c37$export$2e2bcd8739ae039 extends $iuB9z.Text {
    Layers = (0, $9ec1t.default).getInstance();
    constructor(coord, color){
        super();
        this.text = "60\xb0";
        this.style.fill = color;
        this.style.fontSize = 34;
        this.style.fontWeight = "800";
        this.anchor.set(.5);
        this.setAngleValue(coord, 0, 0, 38);
        this.addToLayer();
    }
    addToLayer = ()=>this.Layers.Top.addChild(this);
    setValue = (value)=>this.text = `${value}\xb0`;
    setAngleValue(cCoord, initialAngle, degree, radian) {
        const angle = initialAngle + (0, $eymUv.default)(degree / 2);
        const coord = {
            x: Math.cos(angle) * radian * 1.7 + cCoord.x,
            y: Math.sin(angle) * radian * 1.7 + cCoord.y
        };
        this.setValue(degree);
        this.style.fontSize = radian;
        this.x = coord.x;
        this.y = coord.y;
    }
}

});
parcelRegister("eymUv", function(module, exports) {

$parcel$export(module.exports, "default", () => $0afd35e271dc067b$export$2e2bcd8739ae039);
function $0afd35e271dc067b$export$2e2bcd8739ae039(degree) {
    return degree * (Math.PI / 180);
}

});


parcelRegister("3f3J1", function(module, exports) {

$parcel$export(module.exports, "drawArc", () => $827e00f616855d7e$export$bf8a3f9983094125);
$parcel$export(module.exports, "drawSquare", () => $827e00f616855d7e$export$9340b6a85ea854b9);
function $827e00f616855d7e$export$bf8a3f9983094125(arc, r, sRadian, eRadian, w, color, cClockwise, isStroke) {
    arc.clear();
    if (!isStroke) arc.arc(0, 0, r, sRadian, eRadian, cClockwise).stroke({
        width: w,
        color: color
    });
    else arc.moveTo(Math.cos(sRadian) * r, Math.sin(sRadian) * r).lineTo(0, 0).arc(0, 0, r, sRadian, eRadian, cClockwise).moveTo(0, 0).lineTo(Math.cos(eRadian) * r, Math.sin(eRadian) * r).stroke({
        width: w,
        color: color
    });
    arc.rotation = 0;
}
function $827e00f616855d7e$export$9340b6a85ea854b9(square, dim, startRadian, endRadian, color, cClockwise) {
    square.clear();
    square.rect(0, 0, dim, dim).fill(color).stroke({
        color: 0x000000,
        width: 3
    });
    square.rotation = !cClockwise ? startRadian : endRadian;
}

});


parcelRegister("5Y8dU", function(module, exports) {

$parcel$export(module.exports, "default", () => $c70362288d20b67e$export$2e2bcd8739ae039);
function $c70362288d20b67e$export$2e2bcd8739ae039(A, B, C) {
    // definate vectors
    const BA = [
        A.x - B.x,
        A.y - B.y
    ];
    const BC = [
        C.x - B.x,
        C.y - B.y
    ];
    // dot product
    const dotProduct = BA[0] * BC[0] + BA[1] * BC[1];
    // dimension of vectors
    const magnitudeBA = Math.hypot(BA[0], BA[1]);
    const magnitudeBC = Math.hypot(BC[0], BC[1]);
    // calc angles as radian
    const angleRad = Math.acos(dotProduct / (magnitudeBA * magnitudeBC));
    const angleDeg = Math.round(Number((angleRad * (180 / Math.PI)).toFixed(2)));
    return angleDeg;
}

});

parcelRegister("a92Ax", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f2e4f2e6d187ae4$export$2e2bcd8739ae039);

var $2h5MD = parcelRequire("2h5MD");
function $1f2e4f2e6d187ae4$export$2e2bcd8739ae039(cCoord, coordStart, coordEnd) {
    const startRadian = (0, $2h5MD.default)(cCoord, coordStart);
    const endRadian = (0, $2h5MD.default)(cCoord, coordEnd);
    return {
        startRadian: startRadian,
        endRadian: endRadian
    };
}

});

parcelRegister("jtirH", function(module, exports) {

$parcel$export(module.exports, "default", () => $34c5a2df4ae2bc79$export$2e2bcd8739ae039);
function $34c5a2df4ae2bc79$export$2e2bcd8739ae039(cCoord, cCircumPoint, aSide1, aSide2) {
    let angle = Math.atan2(cCircumPoint.y - cCoord.y, cCircumPoint.x - cCoord.x);
    if (angle < 0) angle += 2 * Math.PI;
    let start = aSide1;
    let end = aSide2;
    if (start < 0) start += 2 * Math.PI;
    if (end < 0) end += 2 * Math.PI;
    if (start <= end) return angle >= start && angle <= end;
    else return angle >= start || angle <= end;
}

});

parcelRegister("9tAmQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $13e632069963336c$export$2e2bcd8739ae039);

var $iuB9z = parcelRequire("iuB9z");

var $9ec1t = parcelRequire("9ec1t");

var $erVR3 = parcelRequire("erVR3");

var $d0yDD = parcelRequire("d0yDD");

var $cdlGy = parcelRequire("cdlGy");

var $jYh5T = parcelRequire("jYh5T");
class $13e632069963336c$export$2e2bcd8739ae039 {
    Layers = (0, $9ec1t.default).getInstance();
    isShownSegment = false;
    line = new (0, $d0yDD.default)({
        color: 0xFF0000,
        width: 6
    });
    segments;
    cCoord;
    constructor(cCoord){
        this.cCoord = cCoord;
        this.addSegments();
    }
    handleSegmentVisible(v) {
        this.isShownSegment = v;
        this.segmentVisibleWithAnimated(v);
    }
    segmentVisibleWithAnimated(v) {
        const sOpacity = v ? 0 : 1;
        const tOpacity = v ? 1 : 0;
        const duration = 100;
        const elms = [
            this.line,
            ...this.segments
        ];
        elms.forEach((elm)=>elm.alpha = sOpacity);
        (0, $erVR3.rootEventBus).emit((0, $erVR3.EnumRootEventBus).drawElements);
        elms.forEach((elm)=>new (0, $jYh5T.default)(elm, sOpacity, tOpacity, duration, ()=>!v ? elm.clear() : ""));
    }
    addSegments() {
        this.segments = Array(2).fill("").map((_)=>new $iuB9z.Graphics());
        this.Layers.BottomUnder.addChild(...this.segments);
    }
    draw(radius, radians, [sCoord, eCoord], clockwise) {
        if (!this.isShownSegment) return;
        this.line.draw(sCoord, eCoord);
        (0, $cdlGy.default)(this.segments, this.cCoord, radius, radians, clockwise);
    }
    clearAll() {
        this.segments.forEach((s)=>s.clear());
        this.line.clear();
    }
}

});
parcelRegister("cdlGy", function(module, exports) {

$parcel$export(module.exports, "default", () => $fcb2dbd26932bc43$export$2e2bcd8739ae039);

var $hCdov = parcelRequire("hCdov");
function $fcb2dbd26932bc43$export$2e2bcd8739ae039(segments, cCoord, radius, radians, clockwise) {
    const points = (0, $hCdov.default)(cCoord, radians, radius);
    const _rs = [
        [
            radians[0],
            radians[1]
        ],
        [
            radians[1],
            radians[0]
        ]
    ];
    const rs = clockwise ? _rs : _rs.reverse();
    const colors = [
        0xFDEEE4,
        0xDDF9FF
    ];
    segments.forEach((segment, sI)=>{
        segment.clear().moveTo(points[0].x, points[0].y).lineTo(points[1].x, points[1].y).arc(cCoord.x, cCoord.y, radius, rs[sI][0], rs[sI][1]).fill(colors[sI]);
    });
}

});

parcelRegister("jYh5T", function(module, exports) {

$parcel$export(module.exports, "default", () => $016f335fbdc70656$export$2e2bcd8739ae039);

var $6m47o = parcelRequire("6m47o");

var $1PAc2 = parcelRequire("1PAc2");
class $016f335fbdc70656$export$2e2bcd8739ae039 extends (0, $1PAc2.default) {
    constructor(elm, sOpacity, tOpacity, duration, onComp){
        super();
        const opacity = {
            alpha: sOpacity
        };
        new (0, $6m47o.default).Tween({
            ...opacity
        }).to({
            alpha: tOpacity
        }, duration).easing((0, $6m47o.default).Easing.Linear.None).onUpdate((o)=>elm.alpha = o.alpha).onComplete(()=>onComp()).start();
    }
}

});


parcelRegister("gix9M", function(module, exports) {

$parcel$export(module.exports, "default", () => $4713a546dfab5e00$export$2e2bcd8739ae039);

var $iuB9z = parcelRequire("iuB9z");

var $75RpY = parcelRequire("75RpY");

var $9ec1t = parcelRequire("9ec1t");

var $krubk = parcelRequire("krubk");

var $erVR3 = parcelRequire("erVR3");
class $4713a546dfab5e00$export$2e2bcd8739ae039 extends $iuB9z.Container {
    Game = (0, $75RpY.default).getInstance();
    Layers = (0, $9ec1t.default).getInstance();
    Switcher;
    Header;
    coords;
    handleFunc;
    constructor({ header: header, coords: coords, handleFunc: handleFunc }){
        super();
        this.coords = coords;
        this.handleFunc = handleFunc;
        this.addHeader(header);
        this.addCoord();
        this.addSwitcher();
        this.addToLayer();
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).startedCircleAnim, ()=>this.setVisible(false));
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).completedCircleAnim, ()=>this.setVisible(true));
    }
    setVisible = (v)=>this.visible = v;
    addToLayer = ()=>this.Layers.UI.addChild(this);
    addCoord() {
        const dim = this.Game.getDim();
        let coord = this.coords.horizontal;
        if (dim.WIDTH < dim.HEIGHT) coord = {
            x: dim.WIDTH / 2 + this.coords.vertical.x,
            y: dim.HEIGHT / 2 + this.coords.vertical.y
        };
        Object.assign(this, coord);
    }
    addHeader(header) {
        this.Header = new $iuB9z.Text({
            text: header
        });
        this.Header.anchor.set(.5);
        this.Header.x = 0;
        this.Header.y = -32;
        this.addChild(this.Header);
    }
    addSwitcher() {
        const dim = this.Game.getDim();
        this.Switcher = new (0, $krubk.default)(0x55E39F, this.handleFunc, true);
        this.Switcher.scale.set(dim.WIDTH > dim.HEIGHT ? 1.3 : 1.9);
        this.Switcher.x = 0;
        this.Switcher.y = 0;
        this.addChild(this.Switcher);
    }
    getActivationStatus = ()=>this.Switcher.getActive();
    setActivation(v) {
        const isActive = this.Switcher.getActive();
        if (v && isActive) this.Switcher.handleSwitcher(!isActive);
    }
}

});
parcelRegister("krubk", function(module, exports) {

$parcel$export(module.exports, "default", () => $621ca3294779f8aa$export$2e2bcd8739ae039);

var $iuB9z = parcelRequire("iuB9z");

var $9ec1t = parcelRequire("9ec1t");

var $8xLbP = parcelRequire("8xLbP");

var $erVR3 = parcelRequire("erVR3");

var $16Wgx = parcelRequire("16Wgx");

var $16HUD = parcelRequire("16HUD");
const $621ca3294779f8aa$var$BUTTON_X = 10;
class $621ca3294779f8aa$export$2e2bcd8739ae039 extends $iuB9z.Container {
    Layers = (0, $9ec1t.default).getInstance();
    isActive = false;
    greenBg;
    grayBg;
    button;
    handleSwitch;
    constructor(color, handleSwitch, isAddCon = false){
        super();
        this.handleSwitch = handleSwitch;
        this.greenBg = this.addBg(color);
        this.grayBg = this.addBg(0xDEDEDE);
        this.addButton(0xFFFFFF);
        this.addInteractivity();
        !isAddCon && this.addToLayer();
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).closeSwitcher, ()=>this.handleSwitcherOff());
    }
    addToLayer = ()=>this.Layers.UI.addChild(this);
    getActive = ()=>this.isActive;
    addBg(color) {
        const bgBound = {
            width: 40,
            height: 20
        };
        const bg = new $iuB9z.Graphics().clear().roundRect(-bgBound.width / 2, -bgBound.height / 2, bgBound.width, bgBound.height).fill(color);
        this.addChild(bg);
        return bg;
    }
    handleSwitcher(isActive) {
        this.isActive = isActive;
        this.handleSwitch(this.isActive);
        new (0, $8xLbP.default)(this);
    }
    handleSwitcherOff() {
        if (!this.isActive) return;
        this.handleSwitcher(false);
    }
    addInteractivity() {
        const handleDownFunc = ()=>this.handleSwitcher(!this.isActive);
        (0, $16Wgx.default)(this, {
            handleDownFunc: handleDownFunc
        }, (0, $16HUD.CustomCursorType).pointer, undefined, true);
    }
    setActive(v) {
        this.grayBg.alpha = this.isActive ? 1 - v : v;
        this.greenBg.alpha = this.isActive ? v : 1 - v;
        this.button.x = this.isActive ? 2 * $621ca3294779f8aa$var$BUTTON_X * v : 2 * $621ca3294779f8aa$var$BUTTON_X * (1 - v);
    }
    addButton(color) {
        this.button = new $iuB9z.Graphics().circle(-$621ca3294779f8aa$var$BUTTON_X, 0, 8).fill(color);
        this.addChild(this.button);
    }
}

});
parcelRegister("8xLbP", function(module, exports) {

$parcel$export(module.exports, "default", () => $074e271eb87a9bab$export$2e2bcd8739ae039);

var $6m47o = parcelRequire("6m47o");

var $1PAc2 = parcelRequire("1PAc2");
class $074e271eb87a9bab$export$2e2bcd8739ae039 extends (0, $1PAc2.default) {
    constructor(Switcher){
        super();
        const alpha = 0;
        new (0, $6m47o.default).Tween({
            alpha: alpha
        }).to({
            alpha: 1
        }, 500).easing((0, $6m47o.default).Easing.Linear.None).onUpdate(({ alpha: alpha })=>{
            Switcher.setActive(alpha);
        }).start();
    }
}

});



parcelRegister("beJMG", function(module, exports) {

$parcel$export(module.exports, "getTextureBatchBindGroup", () => $24797d7b1c25d5bc$export$84c26df82650dc9b);

var $awcfo = parcelRequire("awcfo");

var $bLlTJ = parcelRequire("bLlTJ");
"use strict";
const $24797d7b1c25d5bc$var$cachedGroups = {};
function $24797d7b1c25d5bc$export$84c26df82650dc9b(textures, size, maxTextures) {
    let uid = 2166136261;
    for(let i = 0; i < size; i++){
        uid ^= textures[i].uid;
        uid = Math.imul(uid, 16777619);
        uid >>>= 0;
    }
    return $24797d7b1c25d5bc$var$cachedGroups[uid] || $24797d7b1c25d5bc$var$generateTextureBatchBindGroup(textures, size, uid, maxTextures);
}
function $24797d7b1c25d5bc$var$generateTextureBatchBindGroup(textures, size, key, maxTextures) {
    const bindGroupResources = {};
    let bindIndex = 0;
    for(let i = 0; i < maxTextures; i++){
        const texture = i < size ? textures[i] : (0, $bLlTJ.Texture).EMPTY.source;
        bindGroupResources[bindIndex++] = texture.source;
        bindGroupResources[bindIndex++] = texture.style;
    }
    const bindGroup = new (0, $awcfo.BindGroup)(bindGroupResources);
    $24797d7b1c25d5bc$var$cachedGroups[key] = bindGroup;
    return bindGroup;
}

});

parcelRegister("6RGCN", function(module, exports) {

$parcel$export(module.exports, "CanvasPool", () => $cb3b5b020b2ab749$export$e56d0a06781accc9);

var $iCGeI = parcelRequire("iCGeI");

var $NbSCN = parcelRequire("NbSCN");

var $2GH55 = parcelRequire("2GH55");
"use strict";
class $cb3b5b020b2ab749$export$62d9f0b8aada09d7 {
    constructor(canvasOptions){
        this._canvasPool = /* @__PURE__ */ Object.create(null);
        this.canvasOptions = canvasOptions || {};
        this.enableFullScreen = false;
    }
    /**
   * Creates texture with params that were specified in pool constructor.
   * @param pixelWidth - Width of texture in pixels.
   * @param pixelHeight - Height of texture in pixels.
   */ _createCanvasAndContext(pixelWidth, pixelHeight) {
        const canvas = (0, $iCGeI.DOMAdapter).get().createCanvas();
        canvas.width = pixelWidth;
        canvas.height = pixelHeight;
        const context = canvas.getContext("2d");
        return {
            canvas: canvas,
            context: context
        };
    }
    /**
   * Gets a Power-of-Two render texture or fullScreen texture
   * @param minWidth - The minimum width of the render texture.
   * @param minHeight - The minimum height of the render texture.
   * @param resolution - The resolution of the render texture.
   * @returns The new render texture.
   */ getOptimalCanvasAndContext(minWidth, minHeight, resolution = 1) {
        minWidth = Math.ceil(minWidth * resolution - 1e-6);
        minHeight = Math.ceil(minHeight * resolution - 1e-6);
        minWidth = (0, $NbSCN.nextPow2)(minWidth);
        minHeight = (0, $NbSCN.nextPow2)(minHeight);
        const key = (minWidth << 17) + (minHeight << 1);
        if (!this._canvasPool[key]) this._canvasPool[key] = [];
        let canvasAndContext = this._canvasPool[key].pop();
        if (!canvasAndContext) canvasAndContext = this._createCanvasAndContext(minWidth, minHeight);
        return canvasAndContext;
    }
    /**
   * Place a render texture back into the pool.
   * @param canvasAndContext
   */ returnCanvasAndContext(canvasAndContext) {
        const canvas = canvasAndContext.canvas;
        const { width: width, height: height } = canvas;
        const key = (width << 17) + (height << 1);
        canvasAndContext.context.resetTransform();
        canvasAndContext.context.clearRect(0, 0, width, height);
        this._canvasPool[key].push(canvasAndContext);
    }
    clear() {
        this._canvasPool = {};
    }
}
const $cb3b5b020b2ab749$export$e56d0a06781accc9 = new $cb3b5b020b2ab749$export$62d9f0b8aada09d7();
(0, $2GH55.GlobalResourceRegistry).register($cb3b5b020b2ab749$export$e56d0a06781accc9);

});

parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = 'browser';
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ''; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return '/';
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});


var $75RpY = parcelRequire("75RpY");

var $75RpY = parcelRequire("75RpY");

var $erVR3 = parcelRequire("erVR3");

var $fGH3X = parcelRequire("fGH3X");

var $iiVV4 = parcelRequire("iiVV4");

var $5ehzb = parcelRequire("5ehzb");

var $1B2xl = parcelRequire("1B2xl");

var $darcK = parcelRequire("darcK");
const $f63d277292fb53b7$export$7a003cdef7722780 = [
    0xFC99C4,
    0xF94F6F
];
const $f63d277292fb53b7$export$c7609d9da8d80867 = {
    x: 600,
    y: 310
};
const $f63d277292fb53b7$export$ca8f2c484d507a5d = 200;
const $f63d277292fb53b7$export$95c476c8e1b0007 = [
    Math.PI,
    -Math.PI / 2,
    0
];
const $f63d277292fb53b7$export$bdea539c223eec51 = [
    0x000000,
    0x000000,
    0xFFBD06
];
const $f63d277292fb53b7$export$186dbbe504e85fe1 = [
    {
        x: 400,
        y: 800
    },
    {
        x: 760,
        y: 800
    },
    {
        x: 1120,
        y: 800
    }
];
const $f63d277292fb53b7$export$75f2cc8245aafe09 = [
    {
        x: 60,
        y: 420
    },
    {
        x: -280,
        y: 620
    },
    {
        x: 60,
        y: 620
    }
];
const $f63d277292fb53b7$export$840ec2322406bfdd = {
    x: 1180,
    y: 200
};
const $f63d277292fb53b7$export$1312ecbb29a79419 = {
    x: 200,
    y: 800
};
const $f63d277292fb53b7$export$2e51dc0dfab2d766 = "circle-theorem-5";



var $iuB9z = parcelRequire("iuB9z");
var $f4f762d6adbf2410$export$cb883390c27ec6dd = /*#__PURE__*/ function(EnumEventBus) {
    EnumEventBus["drawElements"] = "DRAW_ELEMENTS";
    EnumEventBus["moveDiameter"] = "MOVE_DIAMETER";
    EnumEventBus["moveCircum"] = "MOVE_CIRCUMFERENCE_POINT";
    EnumEventBus["rotateCircle"] = "ROTATE_CIRCLE";
    EnumEventBus["setRefPoints"] = "SET_REF_POINTS";
    EnumEventBus["genRndmTriangle"] = "GENERATE_RANDOM_TRIANGLE";
    EnumEventBus["segmentMode"] = "SEGMENT_MODE";
    return EnumEventBus;
}({});
const $f4f762d6adbf2410$export$f6644f0f2c90144b = new (0, $iuB9z.EventEmitter)();



var $iD90R = parcelRequire("iD90R");
class $26df15501680ebf4$export$2e2bcd8739ae039 extends (0, $5ehzb.default) {
    constructor(cCoord){
        super(cCoord, (0, $f63d277292fb53b7$export$ca8f2c484d507a5d), (0, $f63d277292fb53b7$export$95c476c8e1b0007));
        this.setCoord();
        this.draw();
        (0, $f4f762d6adbf2410$export$f6644f0f2c90144b).on((0, $f4f762d6adbf2410$export$cb883390c27ec6dd).moveCircum, (v)=>this.moveCircumPoint(v));
        (0, $f4f762d6adbf2410$export$f6644f0f2c90144b).on((0, $f4f762d6adbf2410$export$cb883390c27ec6dd).moveDiameter, (v)=>this.moveDiameterPoints(v));
        (0, $f4f762d6adbf2410$export$f6644f0f2c90144b).on((0, $f4f762d6adbf2410$export$cb883390c27ec6dd).rotateCircle, (v)=>this.moveAllPoints(v));
        (0, $f4f762d6adbf2410$export$f6644f0f2c90144b).on((0, $f4f762d6adbf2410$export$cb883390c27ec6dd).genRndmTriangle, ()=>this.generateRandomlyRadians());
    }
    setRadian(pointInfoArr, isSlider = false) {
        let pIArr = [
            ...pointInfoArr
        ];
        const rest = pIArr.filter((p)=>p.pTag != "p2");
        if (rest.length == 1) pIArr.push({
            pTag: `${rest[0].pTag == "p1" ? "p3" : "p1"}`,
            radian: (0, $darcK.normalizeRadian)(pIArr[0].radian + Math.PI)
        });
        this._setRadian(pIArr, isSlider);
    }
    moveCircumPoint(v) {
        const pointBTag = this.getRedPoints()[1].tag;
        const pointBRefRadian = this.pointRefRadians[1];
        const radian = pointBRefRadian + v / 100 * (Math.PI / 3);
        const pointInfoArr = [
            {
                pTag: pointBTag,
                radian: radian
            }
        ];
        this.setRadian(pointInfoArr, true);
    }
    moveDiameterPoints(v) {
        const pointATag = this.getRedPoints()[0].tag;
        const pointARefRadian = this.pointRefRadians[0];
        const radian = pointARefRadian + v / 100 * (Math.PI / 3);
        const pointInfoArr = [
            {
                pTag: pointATag,
                radian: radian
            }
        ];
        this.setRadian(pointInfoArr, true);
    }
    moveAllPoints(v) {
        const points = this.getRedPoints();
        const pointInfoArr = this.getRefRadians().map((ref, refI)=>({
                pTag: points[refI].tag,
                radian: ref + v / 100 * (Math.PI / 3)
            }));
        this.setRadian(pointInfoArr, true);
    }
    generateRandomlyRadians() {
        const redPoints = this.getRedPoints();
        const currRadians = this.getRadians();
        const newRadians = (0, $1B2xl.getRandomUniqueNumbers)(3, 0, 5).sort((a, b)=>a - b);
        newRadians.map((v)=>v * (Math.PI / 3)).sort().reverse();
        (0, $iD90R.moveAllPointAnim)(currRadians, newRadians, (radian, index)=>this.setRadian([
                {
                    pTag: redPoints[index].tag,
                    radian: radian
                }
            ]));
    }
}



var $9m5D8 = parcelRequire("9m5D8");
class $54030d5baf67e1d8$export$2e2bcd8739ae039 extends (0, $9m5D8.default) {
    constructor(cCoord){
        super(cCoord, [
            "A",
            "B",
            "C"
        ]);
    }
}



var $d0yDD = parcelRequire("d0yDD");

var $erVR3 = parcelRequire("erVR3");
class $0c745e59edffaa48$export$2e2bcd8739ae039 {
    lines = [
        new (0, $d0yDD.default)(),
        new (0, $d0yDD.default)(),
        new (0, $d0yDD.default)()
    ];
    constructor(){
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).startedCircleAnim, ()=>this.clearAll());
    }
    setAllVisible = (status)=>[
            ...this.lines
        ].forEach((l)=>l.visible = status);
    clearAll = ()=>this.lines.forEach((l)=>l.clear());
    draw(points) {
        this.lines.forEach((line, lI)=>{
            const nextIndex = lI != this.lines.length - 1 ? lI + 1 : 0;
            line.draw(points[lI], points[nextIndex]);
        });
    }
}



var $erVR3 = parcelRequire("erVR3");

var $g4gW0 = parcelRequire("g4gW0");

var $5Y8dU = parcelRequire("5Y8dU");

var $a92Ax = parcelRequire("a92Ax");

var $eP48i = parcelRequire("eP48i");

class $1663a0b0b17fec99$export$2e2bcd8739ae039 {
    Angles = [
        new (0, $g4gW0.default)("a1", {
            color: (0, $f63d277292fb53b7$export$7a003cdef7722780)[0],
            textColor: (0, $f63d277292fb53b7$export$7a003cdef7722780)[1]
        })
    ];
    constructor(){
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).startedCircleAnim, ()=>this.setAllVisible(false));
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).completedCircleAnim, ()=>this.setAllVisible(true));
    }
    setAllVisible = (v)=>this.Angles.forEach((angle)=>angle.setVisible(v));
    getAngles = ()=>this.Angles;
    draw(points, clockwise) {
        this.Angles.forEach((_, aI)=>{
            const P = {
                prev: points[2],
                curr: points[1],
                next: points[0]
            };
            const degree = (0, $5Y8dU.default)(points[0], points[1], points[2]);
            this.drawAngle(this.Angles[aI], P, degree, clockwise);
        });
    }
    drawAngle(angle, p, degree, clockwise) {
        const { startRadian: startRadian, endRadian: endRadian } = (0, $a92Ax.default)(p.curr, p.prev, p.next);
        const smllDistance = Math.min((0, $eP48i.default)(p.curr, p.prev), (0, $eP48i.default)(p.curr, p.next));
        angle.smallDistance = Math.floor(smllDistance);
        angle.draw(p.curr, startRadian, endRadian, degree, !clockwise);
        angle.x = p.curr.x;
        angle.y = p.curr.y;
        angle.rotation = 0;
    }
}



var $b2sIL = parcelRequire("b2sIL");


const $a6d2d6e249b7954e$var$SliderGen = [
    {
        head: "move diameter",
        colors: {
            bgColor: 0x21D4FE,
            barColor: 0x000000,
            buttonColor: 0x21D4FE
        },
        onUpdate: (v)=>(0, $f4f762d6adbf2410$export$f6644f0f2c90144b).emit((0, $f4f762d6adbf2410$export$cb883390c27ec6dd).moveDiameter, v - 100)
    },
    {
        head: "move circumference",
        colors: {
            bgColor: 0xB5A1FF,
            barColor: 0x000000,
            buttonColor: 0xB5A1FF
        },
        onUpdate: (v)=>(0, $f4f762d6adbf2410$export$f6644f0f2c90144b).emit((0, $f4f762d6adbf2410$export$cb883390c27ec6dd).moveCircum, v - 100)
    },
    {
        head: "rotate circle",
        colors: {
            bgColor: 0xBFBFBF,
            barColor: 0x000000,
            buttonColor: 0x000000
        },
        onUpdate: (v)=>(0, $f4f762d6adbf2410$export$f6644f0f2c90144b).emit((0, $f4f762d6adbf2410$export$cb883390c27ec6dd).rotateCircle, v - 100)
    }
];
class $a6d2d6e249b7954e$export$2e2bcd8739ae039 extends (0, $b2sIL.default) {
    constructor(){
        super($a6d2d6e249b7954e$var$SliderGen, (0, $f63d277292fb53b7$export$186dbbe504e85fe1), (0, $f63d277292fb53b7$export$75f2cc8245aafe09));
    }
}



var $erVR3 = parcelRequire("erVR3");


var $iD90R = parcelRequire("iD90R");


var $darcK = parcelRequire("darcK");
async function $8b20f6dc333ceb18$export$2721aded6352b5ea(context, onComp) {
    const { circle: circle, LineManager: LineManager, PointManager: PointManager, AngleManager: AngleManager, cCoord: cCoord } = context;
    const centerPoint = PointManager.getPoints()[0];
    const pointsCoord = PointManager.getRedPointsCoord();
    const RedPoints = PointManager.getRedPoints();
    const initialRadian = PointManager.getInitialRadians();
    const angles = AngleManager.getAngles();
    AngleManager.draw(pointsCoord, true);
    circle.setRadians([
        (0, $f63d277292fb53b7$export$95c476c8e1b0007)[0],
        (0, $f63d277292fb53b7$export$95c476c8e1b0007)[0]
    ]);
    (0, $iD90R.drawPointsAnim)([
        centerPoint
    ]);
    await (0, $iD90R.drawCircleAnim)(circle, (0, $f63d277292fb53b7$export$95c476c8e1b0007)[0] + Math.PI * 2, 0, true, cCoord);
    await (0, $iD90R.drawLineAnim)(LineManager.lines[2], pointsCoord[0], pointsCoord[2]);
    await (0, $iD90R.drawLineAnim)(LineManager.lines[1], pointsCoord[2], pointsCoord[1]);
    await (0, $iD90R.drawLineAnim)(LineManager.lines[0], pointsCoord[1], pointsCoord[0]);
    await (0, $iD90R.drawAngleAnim)(angles[0], "90");
    circle.setRadians([
        (0, $f63d277292fb53b7$export$95c476c8e1b0007)[0],
        (0, $f63d277292fb53b7$export$95c476c8e1b0007)[1],
        (0, $f63d277292fb53b7$export$95c476c8e1b0007)[0]
    ]);
    await (0, $iD90R.drawCircleAnim)(circle, (0, $f63d277292fb53b7$export$95c476c8e1b0007)[2], 2, false, cCoord);
    const pointAnimArr = [
        -Math.PI / 3,
        Math.PI / 4 * 3,
        PointManager.getInitialRadians()[1]
    ];
    for(let index = 0; index < pointAnimArr.length; index++){
        const nextRadian = pointAnimArr[index];
        const currRadian = pointAnimArr[index != 0 ? index - 1 : pointAnimArr.length - 1];
        await (0, $iD90R.movePointAnim)(currRadian, nextRadian, (radian)=>PointManager.setRadian([
                {
                    pTag: RedPoints[1].tag,
                    radian: radian
                }
            ]));
    }
    await (0, $iD90R.rotateCircleAnim)((v)=>{
        const arr = Array(3).fill(v).map((v, vI)=>({
                pTag: RedPoints[vI].tag,
                radian: (0, $darcK.normalizeRadian)(initialRadian[vI] + v)
            }));
        PointManager.setRadian(arr);
    });
    onComp();
}



var $e8wW1 = parcelRequire("e8wW1");

class $368d7206f8836939$export$2e2bcd8739ae039 {
    PointManager;
    AngleManager;
    LineManager;
    circle;
    cCoord;
    isSegmentModeActive;
    constructor(PointManager, AngleManager, LineManager, circle, cCoord){
        this.PointManager = PointManager;
        this.AngleManager = AngleManager;
        this.LineManager = LineManager;
        this.circle = circle;
        this.cCoord = cCoord;
        this.isSegmentModeActive = false;
        this.getDelayForStartAnim = ()=>this.isSegmentModeActive ? 150 : 0;
        this.AngleManager.draw(PointManager.getRedPoints(), true);
        this.addCircAnimBut();
        (0, $f4f762d6adbf2410$export$f6644f0f2c90144b).on((0, $f4f762d6adbf2410$export$cb883390c27ec6dd).segmentMode, (v)=>this.isSegmentModeActive = v);
    }
    getDelayForStartAnim;
    addCircAnimBut() {
        new (0, $e8wW1.default)((0, $f63d277292fb53b7$export$840ec2322406bfdd), ()=>this.runAnimations(), ()=>this.getDelayForStartAnim());
    }
    runAnimations() {
        (0, $erVR3.rootEventBus).emit((0, $erVR3.EnumRootEventBus).startedCircleAnim);
        const context = {
            PointManager: this.PointManager,
            AngleManager: this.AngleManager,
            LineManager: this.LineManager,
            circle: this.circle,
            cCoord: this.cCoord
        };
        (0, $8b20f6dc333ceb18$export$2721aded6352b5ea)(context, ()=>{
            (0, $erVR3.rootEventBus).emit((0, $erVR3.EnumRootEventBus).getCircleCoord, {
                x: this.circle.x,
                y: this.circle.y
            });
            (0, $erVR3.rootEventBus).emit((0, $erVR3.EnumRootEventBus).completedCircleAnim);
        });
    }
}



var $3DpJv = parcelRequire("3DpJv");


var $jtirH = parcelRequire("jtirH");
function $3921ad3e32bb2047$export$2e2bcd8739ae039(radians, isbtw) {
    const r = [
        ...radians
    ];
    return isbtw ? r : [
        r[2],
        r[1],
        r[0]
    ];
}



var $75RpY = parcelRequire("75RpY");

var $llFKB = parcelRequire("llFKB");

var $erVR3 = parcelRequire("erVR3");


const $2423474a8eae2a26$var$ButtonStyle = {
    width: 280,
    height: 120,
    wordWrapWidth: 160,
    defaultColor: 0xCECECE,
    hoverColor: 0xDEDEDE,
    pressedColor: 0xC5C5C5,
    borderColor: 0x111111,
    titleColor: 0x111111,
    titleFontSize: 28,
    borderRadius: 22
};
class $2423474a8eae2a26$export$2e2bcd8739ae039 extends (0, $llFKB.default) {
    Game = (0, $75RpY.default).getInstance();
    constructor(){
        super("Generate Random Triangle", $2423474a8eae2a26$var$ButtonStyle, ()=>this.createRandomTriangle());
        this.addCoord();
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).startedCircleAnim, ()=>this.setVisible(false));
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).completedCircleAnim, ()=>this.setVisible(true));
    }
    createRandomTriangle = ()=>(0, $f4f762d6adbf2410$export$f6644f0f2c90144b).emit((0, $f4f762d6adbf2410$export$cb883390c27ec6dd).genRndmTriangle);
    setVisible = (v)=>this.visible = v;
    addCoord() {
        const dim = this.Game.getDim();
        if (dim.WIDTH > dim.HEIGHT) {
            this.x = (0, $f63d277292fb53b7$export$1312ecbb29a79419).x;
            this.y = (0, $f63d277292fb53b7$export$1312ecbb29a79419).y;
            return;
        }
        this.x = dim.WIDTH / 2 - 160;
        this.y = dim.HEIGHT / 2 + 420;
    }
}



var $9tAmQ = parcelRequire("9tAmQ");


var $gix9M = parcelRequire("gix9M");

class $5280795bac39e442$export$2e2bcd8739ae039 extends (0, $gix9M.default) {
    constructor(){
        super({
            header: "Segment Mode",
            coords: {
                vertical: {
                    x: 0,
                    y: 760
                },
                horizontal: {
                    x: 160,
                    y: 240
                }
            },
            handleFunc: (v)=>(0, $f4f762d6adbf2410$export$f6644f0f2c90144b).emit((0, $f4f762d6adbf2410$export$cb883390c27ec6dd).segmentMode, v)
        });
    }
}


class $555d43270888e188$export$2e2bcd8739ae039 extends (0, $9tAmQ.default) {
    constructor(cCoord){
        super(cCoord);
        (0, $f4f762d6adbf2410$export$f6644f0f2c90144b).on((0, $f4f762d6adbf2410$export$cb883390c27ec6dd).segmentMode, (v)=>this.handleSegmentVisible(v));
        new (0, $5280795bac39e442$export$2e2bcd8739ae039)();
    }
}


class $32c8b0ad40c8966c$export$2e2bcd8739ae039 {
    static instance;
    Game = (0, $75RpY.default).getInstance();
    circleRadius = (0, $f63d277292fb53b7$export$ca8f2c484d507a5d);
    cCoord = this.isPortail();
    PointManager = new (0, $26df15501680ebf4$export$2e2bcd8739ae039)(this.cCoord);
    PointTagManager = new (0, $54030d5baf67e1d8$export$2e2bcd8739ae039)(this.cCoord);
    LineManager = new (0, $0c745e59edffaa48$export$2e2bcd8739ae039)();
    AngleManager = new (0, $1663a0b0b17fec99$export$2e2bcd8739ae039)();
    SliderManager = new (0, $a6d2d6e249b7954e$export$2e2bcd8739ae039)();
    InfoSlider = new (0, $fGH3X.default)((0, $f63d277292fb53b7$export$840ec2322406bfdd));
    circle = new (0, $iiVV4.default)(this.cCoord, (0, $f63d277292fb53b7$export$95c476c8e1b0007), (0, $f63d277292fb53b7$export$bdea539c223eec51));
    genRandomTriangle = new (0, $2423474a8eae2a26$export$2e2bcd8739ae039)();
    SegmentChord = new (0, $555d43270888e188$export$2e2bcd8739ae039)(this.cCoord);
    CircleAnimationManager = new (0, $368d7206f8836939$export$2e2bcd8739ae039)(this.PointManager, this.AngleManager, this.LineManager, this.circle, this.cCoord);
    constructor(){
        new (0, $3DpJv.default)();
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).drawElements, ()=>this.drawElements());
        this.drawElements();
    }
    isPortail() {
        const dim = this.Game.getDim();
        if (dim.WIDTH > dim.HEIGHT) return 0, $f63d277292fb53b7$export$c7609d9da8d80867;
        return {
            x: dim.WIDTH / 2,
            y: dim.HEIGHT / 2
        };
    }
    drawElements() {
        const points = this.PointManager.getRedPoints();
        const radians = this.PointManager.getRadians();
        const isBtw = (0, $jtirH.default)(this.cCoord, points[1], radians[0], radians[2]);
        this.circle.draw({
            radians: (0, $3921ad3e32bb2047$export$2e2bcd8739ae039)(radians, isBtw),
            radius: this.circleRadius
        });
        this.LineManager.draw(points);
        this.AngleManager.draw(points, isBtw);
        this.PointTagManager.updateCoord(radians, this.circleRadius);
        this.SegmentChord.draw((0, $f63d277292fb53b7$export$ca8f2c484d507a5d), [
            radians[2],
            radians[0]
        ], [
            points[2],
            points[0]
        ], isBtw);
    }
}



const $86bc6b66113b15e7$var$canvas = document.querySelector("#canvas");
if ($86bc6b66113b15e7$var$canvas) window.context = new (0, $75RpY.default)($86bc6b66113b15e7$var$canvas, (0, $f63d277292fb53b7$export$2e51dc0dfab2d766), ()=>new (0, $32c8b0ad40c8966c$export$2e2bcd8739ae039)());
else console.error("Canvas is not found");


//# sourceMappingURL=index.49430650.js.map
